module.exports = __webpack_public_path__ + "static/media/solution-selection-large@2x.2ab68e56.png";